/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ReviewRequest } from '../model/reviewRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ReviewRequestServiceInterface }                            from './reviewRequest.serviceInterface';


@Injectable()
export class ReviewRequestService implements ReviewRequestServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve one ReviewRequest resource.
     * 
     * @param x_keyclic_app 
     * @param reviewRequest The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReviewRequest(x_keyclic_app: string, reviewRequest: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<ReviewRequest>;
    public getReviewRequest(x_keyclic_app: string, reviewRequest: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReviewRequest>>;
    public getReviewRequest(x_keyclic_app: string, reviewRequest: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReviewRequest>>;
    public getReviewRequest(x_keyclic_app: string, reviewRequest: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling getReviewRequest.');
        }
        if (reviewRequest === null || reviewRequest === undefined) {
            throw new Error('Required parameter reviewRequest was null or undefined when calling getReviewRequest.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<ReviewRequest>(`${this.basePath}/review-requests/${encodeURIComponent(String(reviewRequest))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
